let html = `
<svg><use xlink:href="#sprite-viewed"></use></svg>
`

export default html